/*! React Starter Kit | MIT License | http://www.reactstarterkit.com/ */

import React from 'react';
import Router from 'react-routing/src/Router';
import http from './core/HttpClient';
import App from './components/App';

import NotFoundPage from './components/NotFoundPage';
import ErrorPage from './components/ErrorPage';

import ContactPage from './components/ContactPage';

import GalleryPage from './components/GalleryPage';
import StepPage from './components/StepPage';

import UploadStep from './components/UploadStep';
import ConversionStep from './components/ConversionStep';
import DownloadStep from './components/DownloadStep';

const router = new Router(on => {

  on('*', async (state, next) => {
    const component = await next();
    return component && <App context={state.context}>{component}</App>;
  });

  on('/contact', async () => <ContactPage />);

  on('/', async(state) => {
    const props = {
      title: 'SVG 2 STL',
      description: '3D pringing SVG images made simple. Convert your SVG images to 3D printable STL models online and for free in just three simple steps. ',
      content: <UploadStep />,
      step: 1
    };

    return <StepPage {...props}/>;
  });

  on('/convert/:id', async(state) => {
    const url = '/api/upload/' + state.params.id;
    const upload = await http.get(url);

    if(!upload) return false;

    const conversion = {
      svgId: state.params.id,
      name: upload.name,
      conversions: upload.conversions
    };

    const props = {
      title: 'Convert ' + upload.name + ' to STL',
      svgId: state.params.id,
      description: 'Extrude ' + upload.name + ' to a 3D printable STL with a height of max 300mm online and for free.',
      content: <ConversionStep {...conversion} />,
      step: 2
    };

    return upload && <StepPage {...props} />;
  });

  on('/download/:id', async(state) => {
    const url = '/api/convert/' + state.params.id;
    const conversion = await http.get(url);

    const propsDownload = {
      downloadId: state.params.id,
      name: conversion._upload.name,
      height: conversion.height,
      uploadId: conversion._upload._id
    }

    const props = {
      title: conversion.height + 'mm high STL for ' + conversion._upload.name,
      description: 'Download the 3D printable STL for ' + conversion._upload.name + ' in a height of ' + conversion.height + 'mm for free.',
      content: <DownloadStep {...propsDownload} />,
      step: 3
    };

    return <StepPage {...props} />;
  })

  on('/gallery', async(state) => {
    const props = {
      title: 'Gallery',
      description: 'Browse SVG images other people uploaded and converted. Download already extruded 3D printable STL models or extrude to a height of your choice for free.'
    };

    return <GalleryPage {...props} />;
  })

  on('error', (state, error) => state.statusCode === 404 ?
    <App context={state.context} error={error}><NotFoundPage /></App> :
    <App context={state.context} error={error}><ErrorPage /></App>
  );

});

export default router;



/** WEBPACK FOOTER **
 ** ./src/Router.js
 **/